import React from "react";
import WidgetsCard from "./WidgetsCard";

const Widgets = ({ summary, role, user }) => {
  const widgetConfig = {
    SuperAdmin: [
      {
        key: "totalClients",
        title: "Total Clients",
        link: "/client",
        percentKey: "clientGrowthPercent",
      },
      {
        key: "totalCompanies",
        title: "Total Companies",
        link: "/companies",
        percentKey: "companyGrowthPercent",
      },
      {
        key: "totalEmployees",
        title: "Total Employees",
        percentKey: "employeeGrowthPercent",
      },
      {
        key: "totalPayrollAmount",
        title: "Total Payrolls",
        percentKey: "payrollGrowthPercent",
      },
    ],

    Client: [
      {
        key: "totalCompanies",
        title: "Total Companies",
        link: "/companies",
        percentKey: "companyGrowthPercent",
      },
      {
        key: "totalEmployees",
        title: "Total Employees",
        link: "/employes",
        percentKey: "employeeGrowthPercent",
      },
      {
        key: "totalPayrollAmount",
        title: "Total Payrolls",
        percentKey: "payrollGrowthPercent",
      },
      {
        key: "pendingPayments",
        title: "Pending Payments",
        link: `/pendingpayments/${user?.id}`,
      },
    ],

    Company: [
      {
        key: "totalEmployees",
        title: "Total Employees",
        link: "/employes",
        percentKey: "employeeGrowthPercent",
      },
      {
        key: "newJoiners",
        title: "New Joiners",
      },
      {
        key: "totalPayrollAmount",
        title: "Total Payrolls",
        percentKey: "payrollGrowthPercent",
      },
      {
        key: "pendingPayments",
        title: "Pending Payments",
        link: `/pendingpayments/${user?.id}`,
      },
    ],
  };

  const widgetsToRender = widgetConfig[role] || [];

  return (
    <section className="widgets mt_30">
      <div className="container-fluid">
        <div className="row g-4">
          {widgetsToRender.map((w, index) => {
            const percentValue = w.percentKey
              ? summary?.[w.percentKey] ?? 0
              : 0;

            const isDecrease = percentValue < 0;
            const isActive = index === 0;

            let avatars = [];
            if (isActive) {
              if (role === "SuperAdmin" && w.key === "totalClients") {
                avatars = summary?.clientImages ?? [];
              }
              if (role === "Client" && w.key === "totalCompanies") {
                avatars = summary?.companyLogos ?? [];
              }
              if (role === "Company" && w.key === "totalEmployees") {
                avatars = summary?.employeeImages ?? [];
              }
            }

            return (
              <div className="col-md-3" key={index}>
                <WidgetsCard
                  title={w.title}
                  count={summary?.[w.key] ?? 0}
                  percentage={percentValue}
                  percentageText={
                    isDecrease
                      ? "Decrease this month"
                      : "Increase this month"
                  }
                  trend={isDecrease ? "decrease" : "increase"}
                  link={w.link ?? null}
                  className={isActive ? "gradiant_bg" : ""}
                  avatars={avatars}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Widgets;